import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { ChequeCultureLegacy } from "../../legacyforms/ChequeCultureLegacy";
import "../clap/ClapNoticeInformation.scss";
import "../../../layout/styles/inline-cgos.css";
import { Accordion, AccordionTab } from "primereact/accordion";


import { useDispatch, useSelector } from "react-redux";
import { SportNoticeInformation } from "./SportNoticeInformation";
import { FormulaireSport } from "./FormulaireSport";
import { getUsagerInfo } from "../../../store/actions/usager";
import {setFiche, setFullActionSociale} from "../../../store/actions/actionSociale";
import { ActionSocialeService } from "../../../service/ActionSocialeService";
import { ClapService } from "../../../service/ClapService";
import { AgentService } from "../../../service/AgentService";
import { ChequeCultureService } from "../../../service/ChequeCultureService";
import { LinkProviderService } from "../../../service/LinkProviderService";
import "../clap/DemandeClap.scss";


export const DemandeSport = () => {
  const createMode = "create";
  const editMode = "edit";

  const { mode } = useParams();

  const user = useSelector((state) => state.usager.user);
  const actionSociale = useSelector((state) => state.actionSociale);

  const [editFormData, setEditFormData] = useState(null);
  const [currentActionSociale, setCurrentActionSociale] = useState({});

  const [disabledForm, disableForm] = useState(true);
  const [hiddenNoticeButton, hideNoticeButton] = useState(editMode === mode ? true : false);
  const [activeIndex, setActiveIndex] = useState([0]);

  const [displayBasic, setDisplayBasic] = useState(false);

  const actionSocialeService = new ActionSocialeService();
  const clapService = new ClapService();
  const agentService = new AgentService();
  const chequeCultureService = new ChequeCultureService();

  const linkService = new LinkProviderService();

  const dispatch = useDispatch();
  const history = useHistory();

  const CODE_CAS_ADULTE="3742";
  const CODE_CAS_ENFANT="3743";

  const libelleEnum = { '3742': 'SPORTS-LOISIRS-CULTURE ADULTE','3743': 'SPORTS-LOISIRS-CULTURE ENFANT'};


  if (createMode === mode && (!actionSociale || !actionSociale.cas || !actionSociale.exercice || actionSociale.listActionsSociale.length === 0)) {
    history.push("/choixPeriodeSports/"+actionSociale.cas);
  }


  useEffect(() => {
    if (createMode === mode) {
      fetchDataForCreation();
    } else if (editMode === mode) {
      fetchDataForEdition();
    } else {
      window.location.assign(
        linkService.getRetourEaLoginAgent()
      );
    }
    initActiveIndex();
  }, []);

  useEffect(() => {
    if(createMode === mode) disabledForm ? setActiveIndex([0]) : setActiveIndex([1]);
    if(editMode === mode) setActiveIndex([1]);
  }, [disabledForm]);

  const fetchDataForCreation = () => {
    getFicheAgent();
    getCurrentActionSociale();
  };

  const fetchDataForEdition = () => {
    const as = {
      cas: "",
      exercice: "",
      fiche: "",
      optJustificatif: "",
      iban: "",
      maxVal: 0,
      enfants: [],
      listActionsSociale: [],
    };

    chequeCultureService.getEditDto().then((form) => {
      setEditFormData(form.data);
      as.cas = form.data.codeActionSociale;
      as.exercice = form.data.exercice.toString();

      dispatch(getUsagerInfo()).then((user) => {
          if (user != null && user != undefined) {
            const bareme = {
              casCode: as.cas,
              delegId: user.codeDelegation,
              exercie: as.exercice,
              siActif: 1,
            };

            actionSocialeService.getActionSocialeDematByCASAndDlg(as.cas, user.codeDelegation).then((asList) => {
                Object.values(asList.data).map((item) => {
                  as.listActionsSociale.push(item);
                  if (item.codeActionSociale === as.cas && item.exercice === as.exercice) {
                    setCurrentActionSociale(item);
                  }
                });

                if(mode == editMode && !currentActionSociale?.exercice ){
                  let defaultActionSocial={codeActionSociale: as.cas,codeLibelle: libelleEnum[as.cas],
                  dateDebut: as.exercice,dateFin: as.exercice,codeDelegation: user.codeDelegation ,exercice: as.exercice,defaultEditMode:true
                  }
                  as.listActionsSociale.push(defaultActionSocial);
                  setCurrentActionSociale(defaultActionSocial);
                }

                agentService.getFicheAgent(user.numCgos, as.exercice).then((fiche) => {
                    as.fiche = fiche.data;

                    clapService.getIbanMembre(user.numCgos).then((resIban) => {
                        as.iban = resIban.data.numIBan;

                      clapService.getBaremes(bareme).then((bar) => {
                          as.maxVal = getValeurParticipation(as.fiche.quotientFamilial, bar.data);

                          if(as.cas == CODE_CAS_ENFANT){
                            agentService.getAgentEnfants(as.fiche.numCgos, as.fiche.codeDelegation, as.cas, as.exercice)
                                                         .then((enfants) => {
                                                           let items = [];
                                                           enfants.data.forEach((e) => items.push(e));
                                                           as.enfants = items;
                                                           dispatch(setFullActionSociale(as));
                                                       });
                          }else{
                            dispatch(setFullActionSociale(as));
                          }


                        //commented this lines Remove call to this endpoint for retraite no code position DDP-1045
                        //getOptJustificatif(as.fiche.numCgos, as.fiche.codeSituationAdministrative, as.fiche.codePosition).then((resOpt) => {
                            //as.optJustificatif = resOpt.data;
                          /*
                          */
                        //});
                      });
                    });
                });
              });
          } else {
            window.location(
              linkService.getRetourEaLoginAgent()
            );
          }
        },
        (error) => {
          window.location(linkService.getRetourEaLoginAgent());
        }
      );
    });
  };
    //actionSociale.exercice
  const getFicheAgent = () => {
    agentService.getFicheAgent(user.numCgos, actionSociale.exercice).then((res) => {
      dispatch(setFiche(res.data));
    });
  };


  const getCurrentActionSociale = () => {
    Object.values(actionSociale.listActionsSociale).forEach((as) => {
      if (as.codeActionSociale === actionSociale.cas && as.exercice === actionSociale.exercice) {
        setCurrentActionSociale(as);
        return;
      }
    });
  };

  const getOptJustificatif = (
    numCgos,
    codeSituationAdministrative,
    codePosition
  ) => {
    return clapService.getJustificatifForClapNoticeInfo(
      numCgos,
      codeSituationAdministrative,
      codePosition
    );
  };

  const getValeurParticipation = (qf, tranches) => {
    let val = 0;
    tranches.forEach((el, i) => {
      if (val !== 0) return;

      if (i === tranches.length - 1) {
        if (Number(qf) >= Number(el.borne)) {
          val = tranches[i].valeur;
        }
      } else if (Number(qf) < Number(tranches[i + 1].borne)) {
        val = el.valeur;
      }
    });
    return val;
  };

  const getDateFormat = (date) => {
    return new Date(date).toLocaleDateString("fr-FR", {});
  };

  const checkDateisValid = (date) => {
         return new Date(date) instanceof Date && !isNaN(new Date(date));
   };

  const initActiveIndex = () => {
    if(createMode === mode) setActiveIndex([0]);
    if(editMode === mode) setActiveIndex([1]);
  };

  const handleConfirm = (e) => {
    disableForm(e);
    hideNoticeButton(!e);
  };

  return (
    <div className="grid cld-width">
      <ChequeCultureLegacy />
      <div className="col-12 mx-auto">
        <div
          className="no_shadow_no_border card "
          style={{ display: !displayBasic ? "block" : "none"}}
        >
          <nav aria-label="breadcrumb" class="pt-3">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <a
                  href={linkService.getRetourEaAccueilAgent()}
                  target="_self"
                >
                  Espace Agent
                </a>
              </li>

              <li class="breadcrumb-item">
                <a
                  href={linkService.getRetourEaMembrePrestation()}
                  target="_self"
                >
                  Prestations et Formulaires
                </a>
              </li>

              <li aria-current="page" class="breadcrumb-item active">
                Demande d'une prestation
              </li>
            </ol>
          </nav>
          <p></p>
          {currentActionSociale && (
            <div>
              <h1 style={{ color: "#676767", fontWeight: 300 }}>
                Prestation - {currentActionSociale.exercice}
              </h1>
              <h1 style={{ color: "#676767", fontWeight: 100 }}>
                {currentActionSociale.codeLibelle}
              </h1>
              {createMode === mode && checkDateisValid(currentActionSociale.dateFin) && !currentActionSociale?.defaultEditMode &&
              <div className="info-wrapper-2">
                <span style={{fontSize: "10.0pt", fontFamily: "Tahoma, sans-serif",}}>
                  Demande de prestation possible jusqu'au {" "}
                  {getDateFormat(currentActionSociale.dateFin)}
                </span>
              </div>}
              {!checkDateisValid(currentActionSociale.dateFin) &&
                               <div className="alert alert-danger" style={{textAlign:"center"  }}>
                                            <span style={{ fontSize: "9.0pt", fontFamily: "Tahoma, sans-serif",}}>
                                            Ce formulaire de demande de prestation n’est plus disponible</span>
                               </div>}
            </div>
          )}
          {actionSociale?.listActionsSociale?.length > 0 && actionSociale?.fiche &&
            <Accordion multiple activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
              <AccordionTab header="Comprendre la prestation">
                <SportNoticeInformation mode={mode} hiddenNoticeButton={hiddenNoticeButton} onConfirm={(e) => handleConfirm(e)} />
              </AccordionTab>

              <AccordionTab header={ createMode === mode ? "Envoyer une demande" : "Compléter votre demande" } disabled={true}>
                <FormulaireSport mode={mode} oldForm={editFormData} />
              </AccordionTab>
            </Accordion>
          }
        </div>
      </div>
    </div>
  );
};
